import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { interfaces } from '@daas-consulting/core-cross-interfaces';
import { BehaviorSubject, Observable } from 'rxjs';

type Data = interfaces.Criteria & { label: string; ariaLabel: string };

@Component({
  selector: 'daas-consulting-list-active-filters',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './list-active-filters.component.html',
  styleUrl: './list-active-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListActiveFiltersComponent implements OnChanges {
  @Input() filters!: interfaces.Criteria[] | null;
  @Input() isRemovable = true;
  @Output() readonly toggleFilter: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() readonly removeFilter: EventEmitter<interfaces.Criteria> =
    new EventEmitter<interfaces.Criteria>();

  readonly data$: Observable<Data[]>;
  readonly #data$ = new BehaviorSubject<Data[]>([]);

  constructor() {
    this.data$ = this.#data$.asObservable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('filters' in changes) {
      const value = changes['filters'].currentValue;
      if (Array.isArray(value)) {
        const aux = value.map((x) => {
          const label = this._getLabel(x);
          const ariaLabel = `Quitar filtro ${label}`;
          const rv: Data = { ...x, label, ariaLabel };
          return rv;
        });
        this.#data$.next(aux);
      }
    }
  }

  handleToggleFilter($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.toggleFilter.emit();
  }

  handleRemoveFilter($event: interfaces.Criteria): void {
    this.removeFilter.emit($event);
  }

  private _getLabel(filter: interfaces.Criteria): string {
    const rv = `${filter.label}: ${filter.value}`;
    return rv;
  }
}
